import { Box, Button, Modal, Typography } from "@mui/material";

export default function ConfirmModal({ 
  show, message, cancel, confirm, btnTitle = "Aceptar", color = "primary"
}) {
  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={show}
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
    >
      <Box
        className="modal-confirm"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "70%",
          bgcolor: "background.paper",
          boxShadow: 24,
          maxWidth: "sm",
          p: 5,
        }}
      >
        <Typography color="primary" mb={3} mt={3} variant="h4" component="h5">
          Confirmar
        </Typography>
        <Typography variant="body1" mb={3}>
          {message}
        </Typography>
        <Box className="modal-actions">
          <Button
            variant="contained"
            color={color}
            onClick={confirm}
            sx={{ mt: 2, color: 'white'}}
          >
            {btnTitle}
          </Button>
          <Button onClick={cancel}>
            Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
